<template>
  <tr>
    <td>{{ $store.getters['rummage/paymentMethod'](paymentMethod)?.name || '--' }}</td>
    <td class="text-right">{{ total | currency }}</td>
    <td class="text-right">{{ tipAmount | currency }}</td>
    <td class="text-right">{{ sum | currency }}</td>
  </tr>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'

  export default {
    mixins: [
      Currenciable,
    ],

    props: [
      'paymentMethod',
      'total',
      'tipAmount',
    ],

    computed: {
      sum () {
        return parseFloat(this.total) + parseFloat(this.tipAmount)
      },
    },
  }
</script>
